import { useState, useEffect, useCallback, useContext } from 'react';

import ApplicationContext from 'components/ApplicationContext';

export default function useLessonListOpen(playerRef) {
  const {
    screenWidth: { isMobile, isTablet },
  } = useContext(ApplicationContext);

  const lessonListIsPopupMode = isMobile || isTablet;
  const [isLessonListOpen, setIsLessonListOpen] = useState(
    !lessonListIsPopupMode,
  );

  useEffect(() => {
    setIsLessonListOpen(!lessonListIsPopupMode);
  }, [lessonListIsPopupMode]);

  useEffect(() => {
    if (lessonListIsPopupMode && isLessonListOpen) {
      document.body.style.position = 'fixed';
      return () => {
        document.body.style.position = 'unset';
      };
    }
    return () => {};
  }, [isLessonListOpen, lessonListIsPopupMode]);

  const onLessonListPopupModeOpen = useCallback(() => {
    setIsLessonListOpen(true);
    if (playerRef.current) {
      playerRef.current.handlePause();
    }
  }, [playerRef]);

  const onLessonListPopupModeClose = useCallback(() => {
    if (lessonListIsPopupMode) {
      setIsLessonListOpen(false);
    }
  }, [lessonListIsPopupMode]);

  return {
    isLessonListOpen,
    lessonListIsPopupMode,
    onLessonListPopupModeOpen,
    onLessonListPopupModeClose,
  };
}
